import { useQuery } from '@tanstack/react-query';
import { fetchFeaturedPreCanneds } from '../../api/sportsbook-api';
import { RefetchInterval, StaleTime } from '../../sportsbook-constants';
import { SPORTSBOOK_QUERY_KEY } from '../queries-constants';

type Params = {
	sportId?: string;
	leagueId?: string;
};

type Options = {
	staleTime?: StaleTime;
	refetchInterval?: RefetchInterval;
	isEnabled?: boolean;
};

/**
 * Hook for querying featured pre-canneds
 */
const useQueryFeaturedPreCanneds = (params: Params, options?: Options) =>
	useQuery({
		queryKey: [SPORTSBOOK_QUERY_KEY, 'featured-pre-canneds', params.sportId, params.leagueId],
		queryFn: () => fetchFeaturedPreCanneds(params.sportId, params.leagueId),
		enabled: options?.isEnabled,
		staleTime: options?.staleTime ?? StaleTime.ZERO,
		refetchInterval: options?.refetchInterval,
		meta: {
			errorMessage: `Failed to fetch featured pre-canneds`
		}
	});

export default useQueryFeaturedPreCanneds;
